import React, { useState, useEffect } from 'react';

const Loader = ({ message = 'Loading trading platform' }) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress(prev => {
        if (prev >= 100) {
          clearInterval(interval);
          return 100;
        }
        return prev + 2;
      });
    }, 40);
    return () => clearInterval(interval);
  }, []);

  const candleData = [
    { bull: true, wt: 8, body: 28, wb: 6 },
    { bull: false, wt: 10, body: 22, wb: 8 },
    { bull: true, wt: 6, body: 35, wb: 5 },
    { bull: false, wt: 12, body: 18, wb: 10 },
    { bull: true, wt: 5, body: 42, wb: 7 },
    { bull: true, wt: 7, body: 32, wb: 6 },
    { bull: false, wt: 9, body: 25, wb: 8 },
    { bull: true, wt: 4, body: 48, wb: 5 },
    { bull: false, wt: 11, body: 20, wb: 9 },
    { bull: true, wt: 6, body: 38, wb: 6 },
    { bull: true, wt: 5, body: 52, wb: 4 },
    { bull: false, wt: 8, body: 16, wb: 7 },
  ];

  return (
    <div className="fixed inset-0 z-[9999] flex flex-col items-center justify-center gap-8"
      style={{ background: '#ffffff' }}>
      
      {/* Brand Logo */}
      <div style={{ textAlign: 'center', marginBottom: '0.5rem' }}>
        <div style={{ 
          display: 'inline-flex', 
          alignItems: 'center', 
          justifyContent: 'center', 
          width: 52, 
          height: 52, 
          borderRadius: 14, 
          background: 'linear-gradient(135deg, #7c3aed, #8b5cf6, #6366f1)', 
          marginBottom: '0.75rem', 
          boxShadow: '0 8px 25px rgba(139,92,246,0.3)' 
        }}>
          <span style={{ fontFamily: "'Syne',sans-serif", fontSize: '1.6rem', fontWeight: 800, color: '#ffffff' }}>A</span>
        </div>
        <div style={{ fontFamily: "'Syne',sans-serif", fontSize: '1.5rem', fontWeight: 800, color: '#5b21b6', letterSpacing: '-0.02em' }}>
          Anzo <span style={{ background: 'linear-gradient(135deg, #7c3aed, #8b5cf6, #6366f1)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>Trade</span>
        </div>
      </div>

      {/* Candle Stage */}
      <div className="flex items-end justify-center gap-2.5 h-[120px]">
        {candleData.map((candle, idx) => (
          <div
            key={idx}
            className={`flex flex-col items-center animate-candle-rise ${candle.bull ? 'bull' : 'bear'}`}
            style={{ animationDelay: `${idx * 0.12}s` }}
          >
            <div 
              className="wick-top" 
              style={{ 
                height: candle.wt, 
                width: '2px', 
                borderRadius: '1px', 
                background: candle.bull ? 'rgba(139,92,246,0.5)' : 'rgba(99,102,241,0.5)' 
              }} 
            />
            <div 
              className="body" 
              style={{ 
                height: candle.body, 
                width: '18px', 
                borderRadius: '3px', 
                background: candle.bull 
                  ? 'linear-gradient(180deg, #a78bfa 0%, #7c3aed 100%)' 
                  : 'linear-gradient(180deg, #818cf8 0%, #6366f1 100%)',
                boxShadow: candle.bull 
                  ? '0 0 8px rgba(139,92,246,0.4)' 
                  : '0 0 8px rgba(99,102,241,0.35)'
              }} 
            />
            <div 
              className="wick-bottom" 
              style={{ 
                height: candle.wb, 
                width: '2px', 
                borderRadius: '1px', 
                background: candle.bull ? 'rgba(139,92,246,0.5)' : 'rgba(99,102,241,0.5)' 
              }} 
            />
          </div>
        ))}
      </div>

      {/* Loading Label */}
      <div className="text-xs font-medium tracking-[0.18em] uppercase animate-pulse" style={{ color: '#64748b', fontFamily: "'Poppins', sans-serif" }}>
        {message}
      </div>

      {/* Progress Bar */}
      <div className="w-[200px] h-[2px] rounded-full overflow-hidden" style={{ background: '#e2e8f0' }}>
        <div
          className="h-full rounded-full transition-all duration-100"
          style={{ background: 'linear-gradient(to right, #7c3aed, #8b5cf6, #6366f1)', width: `${progress}%` }}
        />
      </div>

      <style>{`
        @keyframes candle-rise {
          0% { opacity: 0; transform: scaleY(0); }
          60% { opacity: 1; transform: scaleY(1.05); }
          80% { transform: scaleY(0.97); }
          100% { opacity: 1; transform: scaleY(1); }
        }
        .animate-candle-rise {
          animation: candle-rise 1.5s ease-out forwards;
          opacity: 0;
          transform: scaleY(0);
          transform-origin: bottom;
        }
      `}</style>
    </div>
  );
};

export default Loader;